module.exports = __webpack_public_path__ + "img/LOGOS_02.85890363.jpg";